// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__33R_g","buscador":"Formulario_buscador__-S5TY","btn_block":"Formulario_btn_block__3aEr_"};